exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-entry {\n\tfont-size: 12px;\n}\n\n.log-entry .time {\n\tfont-weight: 600;\n}\n\n.log-entry .message {\n\tdisplay: block;\n\tfont-size: 16px;\n}\n\n.log-entry a {\n\ttext-decoration: none !important;\n}\n\n.log-entry .map img {\n\tborder-radius: 5px;\n\tmargin-top: 5px;\n\twidth: 100%;\n}\n", ""]);

// exports
